import { useContext, useEffect } from 'react';
import { useTrackingManager } from '../tracking/use-tracking-manager';
import { PortalContext } from '../context/portal-context';
import { UserStatus, Vehicle } from '@esportal/portal-service';
import { usePageTrackingContext } from '../context/page-tracking-context';
import { formatOwnership } from '../tracking/tracking-helper';

export const usePageTracker = ({
	contentId,
	vehicle,
	isVoucherPage,
}: {
	contentId: string;
	vehicle?: Vehicle[];
	isVoucherPage?: boolean;
}) => {
	const { isFirstLoad } = usePageTrackingContext();
	const trackingManager = useTrackingManager();

	const { portalService } = useContext(PortalContext);
	const userData = portalService.getPerson().getValue();
	let userVehicles = null;

	if (
		userData?.portalUser.data.climapro.status == UserStatus.OK ||
		userData?.portalUser.data.climapro.status == UserStatus.PREMATCH
	) {
		userVehicles = portalService.getPersonVehicles().getValue();
	}

	useEffect(() => {
		const ownershipVehicles = isVoucherPage ? vehicle : userVehicles?.vehicles;
		const hasOwnership = isVoucherPage ? vehicle !== undefined : Boolean(vehicle ?? ownershipVehicles?.length);
		const ownershipInfo = hasOwnership ? { vehicle: formatOwnership(ownershipVehicles) ?? [] } : undefined;

		if (isFirstLoad.current) {
			isFirstLoad.current = false;
			trackingManager.trackClubVWGenericFeatureAppLoad({ contentId }, {}, ownershipInfo);
		} else {
			trackingManager.trackClubVWPageLoad({ contentId }, ownershipInfo);
		}
	}, [contentId, trackingManager, vehicle, userVehicles, isFirstLoad, isVoucherPage]);
};
